export default "__VITE_ASSET__DBAi9NQ2__"